export default {
  INVESTOR_PROFILE_ON_FLOW_COMPLETE_REPOSITORY: Symbol.for('INVESTOR_PROFILE_ON_FLOW_COMPLETE_REPOSITORY'),
  UPDATE_INVESTOR_PROFILE_ON_FLOW_COMPLETE_COMMAND: Symbol.for('UPDATE_INVESTOR_PROFILE_ON_FLOW_COMPLETE_COMMAND'),
};
